import React, { useEffect, useMemo, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/organizationReportAction";
import * as uiHelpers from "../OrganizationReportUIHelpers";
import { Modal } from "react-bootstrap";

import {
  currencyFormatter,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage
} from "../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../_metronic/_partials/controls";
import { useOrganizationReportUIContext } from "../OrganizationReportUIContext";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";
import { RoleChecker } from "../../../../RoleChecker";
import { toMonthName } from "../../../../config/helper";

const OrganizationReportTable = props => {
  // OrganizationReport UI Context
  const organizationReportUIContext = useOrganizationReportUIContext();
  const organizationReportUIProps = useMemo(() => {
    return {
      queryParams: organizationReportUIContext.queryParams,
      setQueryParams: organizationReportUIContext.setQueryParams,
      openEditOrganizationReportPage:
        organizationReportUIContext.openEditOrganizationReportPage
    };
  }, [organizationReportUIContext]);

  // Getting curret state of organizationReport list from store (Redux)
  const { currentState } = useSelector(
    state => ({ currentState: state.organizationReports }),
    shallowEqual
  );

  const { totalCount, entities, listLoading, error } = currentState;
  if (error) {
    toast.error(error, toastOption);
  }

  const [toDelete, setToDelete] = useState({});
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setToDelete({});
    setShow(false);
  };
  const handleShow = () => setShow(true);

  const dispatch = useDispatch();
  useEffect(() => {
    //Requset ke Branch Action
    dispatch(
      actions.fetchOrganizationReports(organizationReportUIProps.queryParams)
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationReportUIProps.queryParams, dispatch]);

  const deleteOrganizationReport = () => {
    dispatch(actions.deleteOrganizationReport(toDelete.uuid))
      .then(response => {
        toast.success("OrganizationReport Berhasil Di Hapus", toastOption);
        handleClose();
        dispatch(
          actions.fetchOrganizationReports(
            organizationReportUIProps.queryParams
          )
        );
      })
      .catch(error => {
        toast.error(error.response.message, toastOption);
      });
  };

  const allowEdit = RoleChecker("Edit", "organizationReport");
  const allowDelete = RoleChecker("Delete", "organizationReport");

  // Table columns
  const columns = [
    {
      dataField: "year",
      text: "Tahun",
      sort: true
    },
    {
      dataField: "month",
      text: "Bulan",
      sort: true,
      formatter: cell => {
        return <span>{toMonthName(cell)}</span>;
      }
    },
    {
      text: "Total",
      sort: true,
      formatter: (_, row) => {
        const { zakat, infaq, alms, other } = row;
        const total = +zakat + +infaq + +alms + +other;
        return <span>{currencyFormatter(total)}</span>;
      }
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      formatter: cell => {
        return columnFormatters.StatusColumnFormatter(cell);
      }
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openEditOrganizationReportPage:
          organizationReportUIProps.openEditOrganizationReportPage,
        openDeleteOrganizationReportPage: handleShow,
        setToDelete: setToDelete,
        allowEdit,
        allowDelete
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px"
      }
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: organizationReportUIProps.queryParams.pageSize,
    page: organizationReportUIProps.queryParams.pageNumber
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="uuid"
                data={entities === null ? [] : entities}
                columns={columns}
                // defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  organizationReportUIProps.setQueryParams
                )}
                // selectRow={getSelectRow({
                //   entities,
                //   ids: productsUIProps.ids,
                //   setIds: productsUIProps.setIds,
                // })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Hapus OrganizationReport</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Apakah Anda Yakin Akan Menghapus Laporan Lembaga{" "}
          {/* <span className="text-danger font-weight-bold">{toDelete.name}</span>{" "} */}
          ?
        </Modal.Body>
        <Modal.Footer>
          <button
            type="submit"
            className="btn btn-secondary ml-2 float-right"
            onClick={handleClose}
          >
            Kembali
          </button>
          <button
            type="submit"
            className="btn btn-danger ml-2 float-right"
            onClick={() => deleteOrganizationReport()}
          >
            Hapus
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default OrganizationReportTable;
